import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Avatar from "module-common/Avatar";
import DeleteButton from "./DeleteButtonWithMutation";

export default class Card extends Component {
  static propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    displayName: PropTypes.string,
    displayPicture: PropTypes.string,
    dateCreated: PropTypes.object,
    channel: PropTypes.string
  };

  render() {
    const {
      id,
      name,
      displayName,
      displayPicture,
      dateCreated,
      channel
    } = this.props;
    return (
      <Wrapper>
        <LeftColumn>
          <StyledAvatar image={displayPicture} channel={channel} />
          {/* <DeleteButton id={id} /> */}
        </LeftColumn>
        <RightColumn>
          <Name>{name}</Name>
          {/* <DisplayName>@{displayName}</DisplayName> */}
          {/* <Date>Added at {dateCreated.format("DD/MM/YYYY")}</Date> */}
        </RightColumn>
        <XIcon>
          <DeleteButton id={id} />
        </XIcon>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  width: 180px;
  height: 70px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin-right: 13px;
  margin-left: 13px;
  margin-bottom: 8px;
  position: relative;
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 70px;
  align-items: center;
  padding: 10px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;
const StyledAvatar = styled(Avatar)`
  margin-bottom: 15px;
`;
// const DisplayName = styled.div`
//   line-height: 1.2;
// `;
const Name = styled.div`
  line-height: 3.5;
  font-size: 10pt;
`;
const XIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;
// const Date = styled.div`
//   font-size: 0.7rem;
//   margin-top: 8px;
//   color: ${props => props.theme.uiText};
// `;



// WEBPACK FOOTER //
// ./src/module-first-time/connect-account/ChannelCard.js